/*
 * The Mini Cart custom element.
 * This is a complicated Mini Cart, however once explained, it should all make sense.
 * 
 * As EE tend to have special offers in the Mini Cart, we need to ensure that
 * we are performing checks every time the cart is updated. This is so we can 
 * manually add/remove any items.
 * 
 * To do this, we ise a MutationObserver to listen for any changes to the data-updating
 * attribute assigned to this element.
 * 
 * When the attribute is changed, we run the mutationCallback() function. This function
 * checks for the value of the data-updating attribute and if the value equals "updated"
 * we then run our promises.
 * 
 * The Promises are an array of promise functions that will render the HTML for the Mini
 * Cart once they are all complete.
 * 
 * If there are no promises, we will simply render the Mini Cart.
 * 
 * To render the Mini Cart any time, simply change the "data-updating" attribute to
 * "updating" and then remove the attribute once complete.
 * 
 * To Reiterate - the rendering and the updating of the Mini cart are completely separate.
 */
class CartMini extends HTMLElement {
    constructor() {
        super();

        document.addEventListener(Events().itemAdded.name, this.open.bind(this));

        this.cart = window.theme.cart;
        this.cartCount = document.querySelectorAll('[data-cart-count]') || false;
        // this.gwp = this.querySelector('gift-with-purchase') || false;
        this.gwpEnabled = document.querySelector('[data-mini-cart]').getAttribute('data-gwp-enabled');
        this.secondaryGwpEnabled = document.querySelector('[data-mini-cart]').getAttribute('data-secondary-gwp-enabled');
        console.log("GWP Enabled?", this.gwpEnabled);
        this.paymentMethodsInitialised = false;
        
        this.adding_sample = false;
        this.sample_changing = false;
        this.sample_changing_el = 0;
        this.adding_product = false;
        this.product_changing = false;
        this.product_changing_el = 0;
        this.items_to_add = [];
        this.items_to_remove = [];

        let self = this;

        // Configuration
        window.gwpConfig = {
            sampleGift: {
                enabled: window.free_sample_variants.length > 0,
                ids: window.free_sample_variants, // Replace with your Sample product variant ID
                property: { "_Free Sample": "Yes" },
                threshold: 1,
                blockingProducts: window.products_to_block_sample_one,
                blockingProductsTwo: window.products_to_block_sample_two,
                blockingProductsThree: window.products_to_block_sample_three,
                autoAdd: window.sample_auto_add,
                twoSamplesEnabled: window.enable_two_samples
            },
            primaryGWP: {
                enabled: !!window.gwp_product && window.gwp_price_threshold != null,
                id: window.gwp_product, // Replace with Primary GWP variant ID
                threshold: window.gwp_price_threshold, // predefined variable
                property: { "_Free Gift": "Yes" },
            },
            secondaryGWP: {
                enabled: !!window.secondary_gwp_product && window.secondary_gwp_price_threshold != null,
                id: window.secondary_gwp_product, // Replace with Secondary GWP variant ID
                threshold: window.secondary_gwp_price_threshold, // predefined variable
                property: { "_Secondary Free Gift": "Yes" },
            },
            miniGifts: {
                enabled: !!window.free_mini_enabled && window.free_mini_threshold != null,
                threshold: window.free_mini_threshold, // predefined variable
                ids: window.free_mini_variants, // IDs for 3 minis
                blockingProducts: window.products_to_block_mini_one,
                blockingProductsTwo: window.products_to_block_mini_two,
                blockingProductsThree: window.products_to_block_mini_three,
                property: { "_free_mini": "true" },
            },
            miniWithSubscription: {
                enabled: !!window.subscription_free_mini_enabled,
                ids: window.subscription_free_mini_variants, // IDs for 3 minis
                property: { "_sub_free_mini": "true" },
                eligible_product_ids: window.subscription_free_mini_eligible_products
            },
            giftWithBundle: {
                enabled: !!window.gift_with_bundle_enabled,
                id: window.gift_with_bundle_variant, // ID for the gift product
                property: { "_gift_with_bundle": "true" },
                eligible_bundle_name: window.gift_with_bundle_eligible_bundle_name
            }
        };

        const cartSamples = document.querySelector('[data-cart-samples]');
        if (cartSamples) {
            this.sampleListeners();
        }

        const cartMinis = document.querySelector('[data-cart-minis]');
        if (cartMinis) {
            this.minisListeners();
        }

        const cartSubscriptionMinis = document.querySelector('[data-cart-subscription-minis]');
        if (cartSubscriptionMinis) {
            this.subscriptionMinisListeners();
        }

        this.runPromises();

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(this.mutationCallback.bind(this));

        // Start observing the target node for configured mutations
        observer.observe(this, { attributes: true, attributeFilter: ['data-updating'] });

        var url = window.location.href;
        var index = url.indexOf("#");

        if (index !== -1) {
            var hash = url.substring(index + 1);
            if (hash == "opencart") {
                this.open();
            }
        }

        window.cartRenderedEvent = new Event("minicart:rendered");

    }

    open() {
        const drawer = document.querySelector('.cart-mini-container');
        console.log("OPEN ON UPDATE");

        if(!this.paymentMethodsInitialised)  {
            this.showOnlyShopPay();
        }
        else {
            console.log("PAYMENTS ALREADY INTIALISED");
        }
        document.querySelector('body').classList.add('no--scroll');
        drawer.style.display = "block";
        drawer.offsetHeight;
        drawer.classList.add('cart-mini-container--open');
        this.classList.add('is--active');
        this.focus();
        this.setAttribute('open', true);
        this.trapFocus();
    }

    close() {
        const drawer = document.querySelector('.cart-mini-container');
        document.querySelector('body').classList.remove('no--scroll');
        drawer.classList.remove('cart-mini-container--open');
        drawer.querySelector('cart-mini').addEventListener("transitionend", function handler() {
            drawer.style.display = "none";
            drawer.querySelector('cart-mini').removeEventListener("transitionend", handler);
        });
        this.classList.remove('is--active');
        if(window.cartTriggeredManually) {
            document.querySelector('.nav--header__item cart-mini-trigger').focus();
            window.cartTriggeredManually = false;
        } else {
            if(window.lastFocusedElement) {
                window.lastFocusedElement.focus();
            } else {
                document.querySelector('body').focus();
            }
        }
    }

    trapFocus() {
        var dialog = this;
        var firstFocusableElement = dialog.querySelector('cart-mini-trigger .drawer__close');
        var lastFocusableElement = dialog.querySelector('.mini-cart__checkout');

        dialog.addEventListener('keydown', function(e) {
            if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
                e.preventDefault();
                lastFocusableElement.focus();
            } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        });
    }

    showOnlyShopPay() {
        let paymentButtons = document.querySelectorAll('.dynamic-checkout__content [data-testid="grid-cell"]');
        for(let i = 0; i < paymentButtons.length; i++) {
            // if(paymentButtons[i].querySelector('[data-testid="ShopifyPay-button"]') === null) {
            //     paymentButtons[i].style.display = 'none';
            // }

            let shopPayButton = paymentButtons[i].querySelector('[data-testid="ShopifyPay-button"]');
            if(shopPayButton) {
                document.querySelector('.shop-pay-link').style.display = 'flex';
                document.querySelector('.shop-pay-link').addEventListener('click', function() {
                    shopPayButton.click();
                });
            }
        }
        this.paymentMethodsInitialised = true;
    }

    fetchCartData() {

        return new Promise((resolve, reject) => {
            fetch(`${window.routes.cart_url}`, { ...fetchConfig() })
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    resolve(data);
                })
                .catch(e => {
                    console.error(e);
                    reject(e);
                });
        });
    }

    fetchCartSections() {

        const sections = this.getSectionsToRender().map((section) => section.section).join(',');

        return fetch(`?sections=${sections}`)
            .then((response) => {
                console.log('sections', sections);
                return response.text()
            })
            .then((state) => {
                return JSON.parse(state);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    mutationCallback(mutationsList) {

        for (const mutation of mutationsList) {

            if (mutation.type !== "attributes") {
                return
            }

            if (mutation.target.dataset.updating == "updated") {
                this.runPromises();
            }
        }
    }

    runPromises() {

        // Store Promises as an array
        let promises = [];

        // Definte any promises here as separate functions.

        if( gwpConfig.primaryGWP.enabled || 
            gwpConfig.secondaryGWP.enabled || 
            gwpConfig.miniGifts.enabled || 
            gwpConfig.sampleGift.enabled || 
            gwpConfig.miniWithSubscription.enabled ||
            gwpConfig.giftWithBundle.enabled ) {
            const gwpPromises = this.checkAllGWPs();
            promises.push(gwpPromises);
        }

        // If there are no promises, just render the HTML
        if (promises.length == 0) {

            this.renderInnerHTML();

            return;
        }

        Promise.allSettled(promises).then((results) => {
            this.renderInnerHTML();
        });
    }

    renderInnerHTML() {
        let self = this;

        let progressBars = this.querySelectorAll('.progress-bar__step');
        for(let i = 0; i < progressBars.length; i++) {
            progressBars[i].setAttribute('aria-busy', 'true'); 
        }

        // this.fetchCartSections().then((sections) => {

        //     this.getSectionsToRender().forEach((section) => {

        //         const element = document.getElementById(section.id) || false;

        //         if (element) {
        //             const elementToReplace = element.querySelector(section.selector) || element;
        //             elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);
        //         }
        //     });

        //     let cartItemsCount = document.querySelector('#cart-mini-header [data-cart-count]').innerText;

        //     if(cartItemsCount == '0') {
        //         document.querySelector('.additional-checkout-buttons .dynamic-checkout__content').style.display = 'none';
        //     }
        //     else {
        //         document.querySelector('.additional-checkout-buttons .dynamic-checkout__content').style.display = '';
        //     }
        //     this.triggerPromoFieldReload();

        //     this.removeAttribute('data-updating');

        // });

        fetch(`${routes.cart_url}`)
            .then(response => response.text())
            .then(text => {

                const cartRaw = new DOMParser()
                    .parseFromString(text, "text/html");

                let cartItemsCount = cartRaw.querySelector('#cart-mini-header [data-cart-count]');

                // Update cart header and items
                const cartHeaderAndItems = cartRaw.querySelector('#drawer-cart-top').innerHTML;
                document.querySelector('#drawer-cart-top').innerHTML = cartHeaderAndItems;
                
                // Update summary
                const cartSummary = cartRaw.querySelector('#cart-mini-summary');
                if (cartSummary) {
                    document.querySelector('#cart-mini-summary').innerHTML = cartSummary.innerHTML;
                }

                // // Update progress bar
                // const cartProgressBar = cartRaw.querySelector('#cartProgressBar').innerHTML;
                // document.querySelector('#cartProgressBar').innerHTML = cartProgressBar;

                // Update cross sell
                const cartCrossSell = cartRaw.querySelector('#cart-cross-sell').innerHTML;
                document.querySelector('#cart-cross-sell').innerHTML = cartCrossSell;

                //output samples
                const cartSamples = cartRaw.querySelector('[data-cart-samples]');
                if (cartSamples) {
                    document.querySelector('[data-cart-samples]').innerHTML = cartSamples.innerHTML;
                    this.sampleListeners();
                }

                //update free minis countdown
                const freeMinisCountdown = cartRaw.querySelector('#cartFreeMinisCountdown');
                if(freeMinisCountdown) {
                    document.querySelector('#cartFreeMinisCountdown').innerHTML = freeMinisCountdown.innerHTML;
                }

                // update free minis selector
                const freeMinis = cartRaw.querySelector('#cartMinis');
                if(freeMinis) {
                    document.querySelector('#cartMinis').innerHTML = freeMinis.innerHTML;
                    this.minisListeners();
                }

                // update free minis selector
                const subscriptionFreeMinis = cartRaw.querySelector('#cartSubscriptionMinis');
                if(subscriptionFreeMinis) {
                    document.querySelector('#cartSubscriptionMinis').innerHTML = subscriptionFreeMinis.innerHTML;
                    this.subscriptionMinisListeners();
                }

                // render Manual Recommendations
                const cartManualRecommendations = cartRaw.querySelector('#manualRecommendations');
                if(cartManualRecommendations) {
                    document.querySelector('#manualRecommendations').innerHTML = cartManualRecommendations.innerHTML;
                }

                // toggle Promo Field
                // if(cartItemsCount.innerText == '0') {
                //     document.querySelector('.cart-promo-wrapper').style.display = 'none';
                // } else {
                //     document.querySelector('.cart-promo-wrapper').style.display = 'block';
                // }

                // Check samples and remove if cart has no other items
                // const cartSamplesAdd = cartRaw.querySelectorAll('[data-sample-add]');
                // if (cartSamplesAdd.length > 0) {
                //     let cartItemCount = cartRaw.querySelector('#cart-mini-header [data-cart-count]').innerText;
                //     if (cartItemCount == '0') {
                //         cartSamplesAdd.forEach(sample => {
                //             if (sample.classList.contains('in-cart')) {
                //                 self.removeSample(sample);
                //                 this.setAttribute('data-updating', "updated");
                //             }
                //         });
                //     }
                // }

                // Check GWP product in case it is still in the cart when it shouldnt be
                // let cartItems = cartRaw.querySelectorAll('cart-mini-item');
                // if (cartItems.length > 0) {
                //     console.log("REMOVING GWP PRODUCT");
                //     cartItems.forEach(item => {
                //         if (item.classList.contains('cart-grid-item--gwp')) {
                //             if (item.dataset.productPrice > 0) {
                //                 document.querySelector('cart-mini').updateItem(item.dataset.lineNumber, 0);
                //             }
                //         }
                //     });
                // }

                // Update Bundle Upsell
                const cartBundleUpsell = cartRaw.querySelector('#cart-bundle-upsell').innerHTML;
                if (cartBundleUpsell) {
                    document.querySelector('#cart-bundle-upsell').innerHTML = cartBundleUpsell;
                }

                // Update header cart count
                // let cartItemsCount = cartRaw.querySelector('#cart-mini-header [data-cart-count]');
                if (cartItemsCount) {
                    document.querySelector('.header [data-cart-count]').innerHTML = cartItemsCount.innerHTML;
                }
                if(window.initLoopBundle) {
                    initLoopBundle('cartItemss'); // added by loop team
                }
                
              // Trigger tontine update
            //   window.TontineApp.app.run();
              document.dispatchEvent(cartRenderedEvent);
            //   let cartItemsCount = document.querySelector('#cart-mini-header [data-cart-count]').innerText;

            if(cartItemsCount == '0') {
                document.querySelector('.additional-checkout-buttons .dynamic-checkout__content').style.display = 'none';
            }
            else {
                document.querySelector('.additional-checkout-buttons .dynamic-checkout__content').style.display = '';
            }
            this.triggerPromoFieldReload();

            this.removeAttribute('data-updating');

            window.YotpoSpotlightObserver.updateRewardPoints();
            })
            .catch(e => {
                console.error(e);
            })
    }

    triggerPromoFieldReload() {
        const event = new Event("refreshPromoField");

        // Dispatch the event.
        document.dispatchEvent(event);
    }

    getSectionInnerHTML(html, selector) {

        // Render sections
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    // Can only do 5 - https://shopify.dev/api/section-rendering#request-sections
    getSectionsToRender() {
        return [
            {
                id: 'drawer-cart-top',
                section: 'drawer-cart-top',
                selector: '.js-contents'
            },
            {
                id: 'cart-mini-summary',
                section: 'cart-mini-summary',
                selector: '.js-contents'
            },
            {
                id: 'cartMinis',
                section: 'cart-minis',
                selector: '.js-contents'
            },
            {
                id: 'drawer-cart-unified',
                section: 'drawer-cart-unified',
                selector: '.js-contents'
            },
            {
                id: 'cartSamples',
                section: 'cart-samples',
                selector: '.cart-samples'
            },
        ];
    };

    // removeItem(line_number){

    //     this.enableLoading();

    //     var body = JSON.stringify({
    //             'line': parseInt(line_number),
    //             'quantity': 0
    //         });

    //     fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), body })
    //     .then((response) => response.json())
    //     .then((parsedState) => { 
    //         // this.getSectionInnerHTML();
    //     })
    //     .catch((e) => {
    //         console.error(e);
    //     });
    // }

    updateItem(line_number, quantity) {

        // Set loading state
        this.enableLoading(line_number);

        const body = JSON.stringify({
            'id': line_number,
            'quantity': quantity,
            // sections: this.getSectionsToRender().map((section) => section.section),
            // sections_url: window.location.pathname
        });

        fetch(`${routes.cart_change_url}`, { ...window.fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text()
            })
            .then((state) => {

                const parsedState = JSON.parse(state);

                this.cart = parsedState;
                // this.disableLoading(line_number);
                this.setAttribute('data-updating', "updated");
            })
            .catch((e) => {
                console.error(e);
            });
    }

    enableLoading(line_number) {
        const currentItem = this.querySelector(`cart-mini-item[data-line-number="${line_number}"]`);
        currentItem.classList.add('loading');
        currentItem.querySelector('.loading-overlay').classList.remove('hidden');
    }

    disableLoading(line_number) {
        const currentItem = this.querySelector(`cart-mini-item[data-line-number="${line_number}"]`);
        currentItem.classList.remove('loading');
        currentItem.querySelector('.loading-overlay').classList.add('hidden');
    }

    sampleListeners() {
        //listen for button clicks,
        var samples = this.querySelectorAll('[data-sample-add]');
        var self = this;
        samples.forEach(function (el) {
            el.addEventListener('click', function (event) {

                if (this.classList.contains('adding')) {
                    return;
                } else if (this.classList.contains('in-cart')) {
                    self.removeSample(this);
                } else {
                    self.addSample(this);
                }
            })

        });

        // var firstSample = this.querySelector('[data-sample-add]');
        // if(firstSample) {
        //     // firstSample.click();
        // }
        //on click, get sample id, add to cart

    }

    minisListeners() {
        //listen for button clicks,
        var samples = this.querySelectorAll('[data-product-add]');
        var parent = this.querySelector('[data-cart-minis]');
        var self = this;
        samples.forEach(function (el) {
            el.addEventListener('click', function (event) {

                if (this.classList.contains('adding')) {
                    return;
                } else if (this.classList.contains('in-cart')) {
                    self.removeProduct(this);
                } else {
                    self.addProduct(parent, this);
                }
            })

        });

    }

    subscriptionMinisListeners() {
        //listen for button clicks,
        var samples = this.querySelectorAll('[data-product-add]');
        var parent = this.querySelector('[data-cart-subscription-minis]');
        var self = this;
        samples.forEach(function (el) {
            el.addEventListener('click', function (event) {

                if (this.classList.contains('adding')) {
                    return;
                } else if (this.classList.contains('in-cart')) {
                    self.removeProduct(this);
                } else {
                    self.addProduct(parent, this);
                }
            })

        });

    }

    addSample(sample) {
        if (this.adding_sample == true) {
            return;
        }

        sample.classList.add('adding');
        var sampleId = sample.getAttribute('data-sample-id');

        //check if existing sample added to bag
        var samples = this.querySelectorAll('[data-sample-add]');

        var self = this;

        if(gwpConfig.sampleGift.twoSamplesEnabled) {
            const inCartSamples = Array.from(self.querySelectorAll('.in-cart[data-sample-id]'));
            if (inCartSamples.length >= 2) {
                sample.classList.remove('adding');
                self.querySelector('.cart-samples__error-message').innerText = "You already have 2 samples in your cart. Please remove a sample if you want to add another.";
            } else {
                //then, add this sample
                this.adding_sample = true;
                this.addToCart(sampleId, true, null, sample);
                sample.classList.remove('adding');
                sample.classList.add('in-cart');
                sample.setAttribute('aria-current', 'true');
                self.querySelector('.cart-samples__error-message').innerText = "";
            }
        }
        else {
            samples.forEach(function (el) {
                //remove if so
                if (el.classList.contains('in-cart')) {

                    var otherId = el.getAttribute('data-sample-id');
                    var otherSample = self.querySelector('.in-cart[data-sample-id="' + otherId + '"]');
                    console.log('REMOVE SAMPLE CALL');
                    self.removeSample(otherSample, false);
                    self.sample_changing = true;
                    self.sample_changing_el = sample;
                    // this.setAttribute('data-updating', "updated");
                }
            });

            if (this.sample_changing == true) {

            } else {
                //then, add this sample
                this.adding_sample = true;
                this.addToCart(sampleId, true, null, sample);
                sample.classList.remove('adding');
                sample.classList.add('in-cart');
                sample.setAttribute('aria-current', 'true');
                // this.setAttribute('data-updating', "updated");
            }
        }


    }

    removeSample(sample, refresh = true) {
        sample.classList.add('removing');
        var sampleId = sample.getAttribute('data-sample-id');
        sample.classList.remove('in-cart');
        sample.setAttribute('aria-current', 'false');
        this.removeFromCart(sampleId, refresh, null, sample);
        const inCartSamples = Array.from(this.querySelectorAll('.in-cart[data-sample-id]'));
        if (inCartSamples.length < 2) {
            const errorContainer = this.querySelector('.cart-samples__error-message');
            if(errorContainer) {
                errorContainer.innerText = "";
            }
        }
        // this.setAttribute('data-updating', "updated");

    }

    addProduct(parent, item) {
        if (this.adding_product == true) {
            return;
        }


        item.classList.add('adding');
        var itemId = item.getAttribute('data-product-id');

        //check if existing sample added to bag
        var items = parent.querySelectorAll('[data-product-add]');

        var self = this;

        items.forEach(function (el) {
            //remove if so
            if (el.classList.contains('in-cart')) {
                var otherId = el.getAttribute('data-product-id');
                var otherProduct = self.querySelector('.in-cart[data-product-id="' + otherId + '"]');
                console.log('REMOVE SAMPLE CALL');
                self.removeProduct(otherProduct, false);
                self.product_changing = true;
                self.product_changing_el = item;
                // this.setAttribute('data-updating', "updated");
            }
        });

        if (this.product_changing == true) {

        } else {
            //then, add this sample
            this.adding_product = true;
            let properties = { '_free_mini': 'true' };
            if(gwpConfig.miniWithSubscription.enabled) {
                properties = {
                    '_free_mini': 'true',
                    '_sub_free_mini': 'true'
                }
            }
            this.addToCart(itemId, true, null, item, properties);
            item.classList.remove('adding');
            item.classList.add('in-cart');
            // this.setAttribute('data-updating', "updated");
        }
    }

    removeProduct(item, refresh = true) {
        item.classList.add('removing');
        var productId = item.getAttribute('data-product-id');
        item.classList.remove('in-cart');
        this.removeFromCart(productId, refresh, null, item);
        // this.setAttribute('data-updating', "updated");

    }


    addToCart(product_id = null, refresh = true, callback = null, button = null, properties = null) {
        if (this.items_to_add.length > 0) {

            var body = '{"items": [';
            this.items_to_add.forEach(function (el, idx, array) {
                if (idx === array.length - 1) {
                    body = body + '{"id": ' + el + ', "quantity": 1}';
                } else {
                    body = body + '{"id": ' + el + ', "quantity": 1},';
                }
            });
            body = body + ']}';
            this.items_to_add = [];

        } else {

            if (product_id == null) {
                return;
            }

            var body = JSON.stringify({
                items: [
                    {
                        id: product_id,
                        quantity: 1
                    }
                ]
            });

            if(properties != null) {
                let item = {
                    id: product_id,
                    quantity: 1,
                    properties: properties
                };
                // item[property.name] = property.value;

                body = JSON.stringify({
                    items: [
                        item
                    ]
                });    
            }
        }

        fetch(`${window.routes.cart_add_url}`, { ...fetchConfig(), body })
            .then((response) => response.json())
            .then((parsedState) => {

                if (parsedState) {
                    if (button) {
                        button.closest('.sample-grid-item').classList.add('in-cart');
                    }
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => { this.adding_sample = false; this.adding_product = false; });
    }



    removeFromCart(product_id = null, refresh = true, callback = null, button = null) {

        console.log("REMOVE FROM CART");
        if (this.items_to_remove.length > 0) {
            var body = '{"updates": {';
            this.items_to_remove.forEach(function (el, idx, array) {
                if (idx === array.length - 1) {
                    body = body + '"' + el + '": 0';
                } else {
                    body = body + '"' + el + '": 0, ';
                }

            });
            body = body + '}}';
            this.items_to_remove = [];
        } else {
            if (product_id == null) {
                return;
            }
            var body = '{"updates":{"' + product_id + '": 0}}';
        }

        fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), body })
            .then((response) => response.json())
            .then((parsedState) => {
                if (parsedState) {
                    if (button) {
                        button.closest('.sample-grid-item').classList.remove('in-cart');
                    }
                    return parsedState;
                }
            })
            .catch((e) => { console.error(e); })
            .finally((parsedCart) => {
                if (this.sample_changing == true) {
                    var sample = this.sample_changing_el;
                    this.sample_changing = false;
                    this.addSample(sample, parsedCart);
                    this.sample_changing_id = 0;
                    this.adding_sample = false;
                    // if(refresh) {
                    //     this.setAttribute('data-updating', "updated");
                    // }
                }

                if (this.product_changing == true) {
                    var parent = button.closest('[data-cart-minis]') ? button.closest('[data-cart-minis]') : button.closest('[data-cart-subscription-minis]');
                    var product = this.product_changing_el;
                    this.product_changing = false;
                    this.addProduct(parent, product);
                    this.product_changing_id = 0;
                    this.adding_product = false;
                }
            });
    }

    getVariantIdsByAttribute(selector, attribute) {
        var minis = this.querySelectorAll(selector);
        return minis.map(element => element.getAttribute(attribute)); 
    }

    // Helper: Check if product variant is in cart
    isInCart = (cart, variantId) => cart.items.some(item => item.variant_id.toString() === variantId);

    checkAllGWPs() {
        return fetch(`${window.routes.cart_url}`, { ...fetchConfig() })
        .then(res => res.json())
        .then(cart => {
            // 1. Which GWPs are configured?
            const hasPrimary = gwpConfig.primaryGWP.enabled;
            const hasSecondary = gwpConfig.secondaryGWP.enabled;
            const hasMinis = gwpConfig.miniGifts.enabled;
            const hasSamples = gwpConfig.sampleGift.enabled;
            const hasSubscriptionMinis = gwpConfig.miniWithSubscription.enabled;
            const hasGiftWithBundles = gwpConfig.giftWithBundle.enabled;

            // 2. Find any gift lines by variant ID
            const giftLines = cart.items.filter(item => {
                return (gwpConfig.primaryGWP.enabled && item.id == gwpConfig.primaryGWP.id) ||
                (gwpConfig.secondaryGWP.enabled && item.id == gwpConfig.secondaryGWP.id) ||
                (gwpConfig.miniGifts.enabled && gwpConfig.miniGifts.ids.includes(item.variant_id.toString())) ||
                (hasSubscriptionMinis && gwpConfig.miniWithSubscription.ids.includes(item.variant_id.toString())) ||
                (hasGiftWithBundles && item.id == gwpConfig.giftWithBundle.id )
            });

            const giftsValue = giftLines.reduce((sum, i) => sum + i.final_price, 0);
            const cartWithoutGifts = cart.items_subtotal_price - giftsValue;

            // 3. Build lists of adds/removes
            const toAdd = [];
            const toRemove = [];

            // Primary gift logic
            if (hasPrimary) {
                const meetsPrimary = cartWithoutGifts >= Number(window.gwp_price_threshold);
                const inCartPrimary = giftLines.some(i => i.id == window.gwp_product);

                if (meetsPrimary && !inCartPrimary) {
                    toAdd.push({
                        id: window.gwp_product,
                        quantity: 1,
                        properties: { "_Free Gift": "Yes" }
                    });
                }
                if (!meetsPrimary && inCartPrimary) {
                    toRemove.push(window.gwp_product);
                }
            }

            // Secondary gift logic
            if (hasSecondary) {
                const meetsSecondary = cartWithoutGifts >= Number(window.secondary_gwp_price_threshold);
                const inCartSecondary = giftLines.some(i => i.id == window.secondary_gwp_product);

                if (meetsSecondary && !inCartSecondary) {
                    toAdd.push({
                        id: window.secondary_gwp_product,
                        quantity: 1,
                        properties: { "_Secondary Free Gift": "Yes" }
                    });
                }
                if (!meetsSecondary && inCartSecondary) {
                    toRemove.push(window.secondary_gwp_product);
                }
            }

            // Mini gift logic

            if (hasMinis) {
                const meetsMini = cartWithoutGifts >= Number(gwpConfig.miniGifts.threshold);
                const inCartMini = giftLines.some(item => gwpConfig.miniGifts.ids.includes(item.variant_id.toString()));
                const blockAutoAddMini1 = cart.items.some(item => gwpConfig.miniGifts.blockingProducts.includes(item.product_id.toString()));
                const blockAutoAddMini2 = cart.items.some(item => gwpConfig.miniGifts.blockingProductsTwo.includes(item.product_id.toString()));
                const blockAutoAddMini3 = cart.items.some(item => gwpConfig.miniGifts.blockingProductsThree.includes(item.product_id.toString()));

                if (meetsMini && !inCartMini) {
                    // toAdd.push({
                    //     id: gwpConfig.miniGifts.ids[0],
                    //     quantity: 1,
                    //     properties: { "_free_mini": "true" }
                    // });

                    if(!blockAutoAddMini1) {
                        toAdd.push({
                            id: gwpConfig.miniGifts.ids[0],
                            quantity: 1,
                            properties: { "_free_mini": "true" }
                        });
                    } else if(!blockAutoAddMini2) {
                        toAdd.push({
                            id: gwpConfig.miniGifts.ids[1],
                            quantity: 1,
                            properties: { "_free_mini": "true" }
                        });
                    } else if(!blockAutoAddMini3) {
                        toAdd.push({
                            id: gwpConfig.miniGifts.ids[2],
                            quantity: 1,
                            properties: { "_free_mini": "true" }
                        });
                    }
                }
                if (!meetsMini && inCartMini) {
                    gwpConfig.miniGifts.ids.forEach(id => {
                        if (this.isInCart(cart, id)) {
                            toRemove.push(id);
                        }
                    });
                }
            }

            // Bundle gift logic

            if (hasGiftWithBundles) {
                const meetsGwb = isEligibleBundleInCart();
                const inCartGwb = giftLines.some(item => gwpConfig.giftWithBundle.id === item.variant_id.toString());

                function isEligibleBundleInCart() {
                    return cart.items.some(item => {
                        return item.properties['_bundleName'] === gwpConfig.giftWithBundle.eligible_bundle_name;
                    });
                }

                if (meetsGwb && !inCartGwb) {
                    toAdd.push({
                        id: gwpConfig.giftWithBundle.id,
                        quantity: 1,
                        properties: gwpConfig.giftWithBundle.property
                    });
                }
                if (!meetsGwb && inCartGwb) {
                    if (this.isInCart(cart, gwpConfig.giftWithBundle.id)) {
                        toRemove.push(gwpConfig.giftWithBundle.id);
                    }
                }
            }
            
            if (hasSubscriptionMinis) {
                const meetsSubMini = this.hasSubscriptionItem(cart);
                const inCartSubMini = giftLines.some(item => gwpConfig.miniWithSubscription.ids.includes(item.variant_id.toString()));
                const eligibleSubMinisEnabled = gwpConfig.miniWithSubscription.eligible_product_ids && gwpConfig.miniWithSubscription.eligible_product_ids.length > 0;
                let eligibleSubProductsInCart = false;

                console.log('EL SUB MINIS ENABLED:', eligibleSubMinisEnabled);
                console.log('CART:', cart);

                if(eligibleSubMinisEnabled) {
                    console.log("PRE-CHECK:");
                    const cartProductIds = cart.items.map((item) => item.product_id.toString());
                    console.log('cart product ids:', cartProductIds);

                    for(let i = 0; i < gwpConfig.miniWithSubscription.eligible_product_ids.length; i++) {
                        try {
                            console.log('Current item: ', gwpConfig.miniWithSubscription.eligible_product_ids[i]);
                            if(cartProductIds.includes(gwpConfig.miniWithSubscription.eligible_product_ids[i])) {
                                eligibleSubProductsInCart = true;
                            }
                        }
                        catch {
                            console.log("ERROR ENCOUNTERED");
                        }
                    }
                    console.log('CHECK:', eligibleSubProductsInCart);

                    if(meetsSubMini && eligibleSubProductsInCart) {
                        if (!inCartSubMini) {
                        toAdd.push({
                            id: gwpConfig.miniWithSubscription.ids[0],
                            quantity: 1,
                            properties: { "_sub_free_mini": "true", "_free_mini": "true" }
                        });
                        }
                    } else {
                        if (!meetsSubMini && inCartSubMini) {
                            gwpConfig.miniWithSubscription.ids.forEach(id => {
                                if (this.isInCart(cart, id)) {
                                    toRemove.push(id);
                                }
                            });
                        }
                    }

                } else {
                    if (meetsSubMini && !inCartSubMini) {
                        toAdd.push({
                            id: gwpConfig.miniWithSubscription.ids[0],
                            quantity: 1,
                            properties: { "_sub_free_mini": "true", "_free_mini": "true" }
                        });
                    }
                    if (!meetsSubMini && inCartSubMini) {
                        gwpConfig.miniWithSubscription.ids.forEach(id => {
                            if (this.isInCart(cart, id)) {
                                toRemove.push(id);
                            }
                        });
                    }
                }

            }

            // Samples logic
            if (hasSamples) {
                console.log("has samples?", hasSamples);
                const meetsSample = cartWithoutGifts >= Number(gwpConfig.sampleGift.threshold);
                const inCartSample = cart.items.some(item => gwpConfig.sampleGift.ids.includes(item.variant_id.toString()));
                const enableAutoAdd = gwpConfig.sampleGift.autoAdd;
                const blockAutoAddSample1 = cart.items.some(item => gwpConfig.sampleGift.blockingProducts.includes(item.product_id.toString()));
                const blockAutoAddSample2 = cart.items.some(item => gwpConfig.sampleGift.blockingProductsTwo.includes(item.product_id.toString()));
                const blockAutoAddSample3 = cart.items.some(item => gwpConfig.sampleGift.blockingProductsThree.includes(item.product_id.toString()));
                const giftCardinCart = cart.items.some(item => item.gift_card === true);
                const paidItemCount = cart.items.filter(item => item.final_price > 0).length; // samples and gwps not counted

                console.log("MEETS: ", meetsSample);
                console.log('inCartSample', inCartSample);
                console.log('enable Auto add', enableAutoAdd);


                if (meetsSample && !inCartSample && enableAutoAdd) {
                    console.log('ENABLE AUTO ADDD');
                    let onlyGIC = giftCardinCart && (paidItemCount === 1);
                    if(!onlyGIC) {
                        console.log("Block sample 1?", blockAutoAddSample1);
                        console.log("Block sample 2?", blockAutoAddSample2);
                        if(!blockAutoAddSample1) {
                            toAdd.push({
                                id: gwpConfig.sampleGift.ids[0],
                                quantity: 1,
                                properties: { "_free_sample": "true" }
                            });
                        } else if(!blockAutoAddSample2) {
                            toAdd.push({
                                id: gwpConfig.sampleGift.ids[1],
                                quantity: 1,
                                properties: { "_free_sample": "true" }
                            });
                        } else if(!blockAutoAddSample3) {
                            toAdd.push({
                                id: gwpConfig.sampleGift.ids[2],
                                quantity: 1,
                                properties: { "_free_sample": "true" }
                            });
                        }
                    }
                }

                if(inCartSample) {
                    // if(blockAutoAddSample1 && this.isInCart(cart, gwpConfig.sampleGift.ids[0])) {
                    //     toRemove.push(gwpConfig.sampleGift.ids[0]);
                    // } else if(blockAutoAddSample2 && this.isInCart(cart, gwpConfig.sampleGift.ids[1])){
                    //     toRemove.push(gwpConfig.sampleGift.ids[1]);
                    // }
                    if (!meetsSample || (giftCardinCart && (paidItemCount === 1))) {
                        gwpConfig.sampleGift.ids.forEach(id => {
                            if (this.isInCart(cart, id)) {
                                toRemove.push(id);
                            }
                        });
                    }
                }
            }

            // 4. Batch add + remove
            const calls = [];

            if (toAdd.length) {
                calls.push(
                    fetch('/cart/add.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: toAdd })
                    }).then(r => r.json())
                );
            }

            if (toRemove.length) {
                const updates = toRemove.reduce((u, id) => {
                    u[id] = 0;
                    return u;
                }, {});
                calls.push(
                    fetch('/cart/update.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    }).then(r => r.json())
                );
            }

            // 5. When all done, re-render mini-cart
            return Promise.all(calls).then(results => {
                document
                    .querySelector('cart-mini')
                    .setAttribute('data-updating', 'render');
                return results;
            });
        });
    }

    hasSubscriptionItem(cart) {
        return cart.items.some(item => Boolean(item.selling_plan_allocation));
    }

}

customElements.define('cart-mini', CartMini);

class QuantitySelector extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-qty-minus]').addEventListener('click', this.minus.bind(this));
        this.querySelector('[data-qty-plus]').addEventListener('click', this.add.bind(this));

        this.miniCart = document.querySelector('cart-mini');
    }

    add() {

        const input = this.querySelector('input');

        let inputValue = parseInt(input.value);
        const newValue = inputValue += 1;

        input.value = newValue;
        
        // Dispatch the change event
        const event = new Event('change');
        input.dispatchEvent(event);
    }

    minus() {

        const input = this.querySelector('input');

        let inputValue = parseInt(input.value);
        const newValue = (inputValue < 0 ? 0 : inputValue -= 1);

        input.value = newValue;
        // Dispatch the change event
        const event = new Event('change');
        input.dispatchEvent(event);
    }
}

customElements.define('quantity-selector', QuantitySelector);

class CartMiniItem extends HTMLElement {

    constructor() {
        super();

        this.form = this.querySelector('form');
        this.quantity = this.querySelector('[name="updates[]"]') || false;
        this.removeTrigger = this.querySelector('[data-remove]') || false;
        this.cart = this.closest('cart-mini');

        if (this.quantity != false) {
            this.quantity.addEventListener('change', this.onChange.bind(this));
        }

        if (this.removeTrigger != false) {
            this.removeTrigger.addEventListener('click', () => {
                this.cart.updateItem(this.dataset.lineNumber, 0);
            })
        }

        // if( this.removeTrigger != false ){
        //     this.quantity.addEventListener('click', this.cart.updateItem(this.dataset.lineNumber, 0));
        // }
    }

    onChange(event) {
        this.cart.updateItem(this.dataset.lineNumber, event.target.value);
    }

    removeItem() {
        this.cart.updateItem(this.dataset.lineNumber, 0);
    }
}

customElements.define('cart-mini-item', CartMiniItem);

class CartMiniTrigger extends HTMLElement {
    constructor() {
        super();

        this.cartMini = document.querySelector('cart-mini');
        this.addEventListener('click', this.onTriggerClick);
    }

    onTriggerClick(event) {
        event.preventDefault();
        const isOpen = this.cartMini.hasAttribute('open');
        isOpen ? this.closeCartMini() : this.openCartMini();
    }

    resetState() {
        this.removeAttribute('open');
        this.cartMini.removeAttribute('open');
    }

    openCartMini() {
        this.setAttribute('open', true);
        this.cartMini.setAttribute('open', true);
        this.cartMini.open();
        window.cartTriggeredManually = true;
    }

    closeCartMini() {
        this.resetState();
        this.cartMini.close();
    }
}

customElements.define('cart-mini-trigger', CartMiniTrigger);

function updateMiniCart() {
    let cart = document.querySelector('[data-mini-cart]');
    cart.setAttribute('data-updating', "updated");
}

document.addEventListener('DOMContentLoaded', function() {
    // Select the target node (the element where you expect the changes to happen)
    const targetNode = document.querySelector('#redeem-points');

    // Options for the observer (which mutations to observe)
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check if any added nodes have the desired class
                for(let node of mutation.addedNodes) {
                    if(node.nodeType === 1 && node.classList.contains('yotpo-redemption-option-details-text')) {
                        if(node.querySelectorAll('.yotpo-add-to-cart-success-button').length > 0) {
                            updateMiniCart();
                            let viewCartButton = node.querySelector('.yotpo-add-to-cart-success-button button');
                            // viewCartButton.setAttribute('disabled', 'disabled');
                            viewCartButton.addEventListener('click', function(e) {
                                e.stopImmediatePropagation();
                                document.querySelector('header nav cart-mini-trigger').click();
                            }, true);
                        }
                    }
                }
            }
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if(targetNode) {
        observer.observe(targetNode, config);
    }
});

document.addEventListener("minicart:rendered", function(e) {
    console.log('minicart: UPDATED');
    let rewardsPageATCButton = document.querySelector('.yotpo-add-to-cart-success-button button')
    rewardsPageATCButton && rewardsPageATCButton.removeAttribute('disabled');
    hybridSelectInit();
  },
  false,
);